// extracted by mini-css-extract-plugin
module.exports = {"detail":"NextAppointment_detail__uCTeH","who":"NextAppointment_who__xG654","strip":"NextAppointment_strip__UB00C"};